import React from 'react';
import styles from './Card.module.scss';
import { stripTags } from '../../../../../Utils/sanitize';

const Card = ({ icon, title, description, steps, onClick, variant }) => {
  if (variant === 'recipe') {
    return (
      <div className={`${styles.card} ${styles.recipeCard}`} onClick={onClick}>
        <span className={`material-icons ${styles.icon}`}>{icon}</span>
        <div className={styles.recipeDetails}>
          <h5 className={styles.recipeTitle}>{title}</h5>
          <span className={styles.openRecipe}>Open Recipe {'>'}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <span className={`material-icons ${styles.icon}`}>{icon}</span>
      <h5 className={styles.title}>{title}</h5>
      <p className={styles.description}>{stripTags(description)}</p>
      <p className={styles.steps}>{`${steps.length} Steps`}</p>
      <button className={`btn btn-primary ${styles.button}`} onClick={onClick}>Open Workflow</button>
    </div>
  );
};

export default Card;